export default "__VITE_ASSET__B$Fp$Z73__"